export function removeRowsWithAtLeastOneEmptyElement(rows: any[]): any[] {
    const validRows: any[] = [];

    rows.map((row) => {
        if (isEmpty(row)) {
            return;
        }

        for (let element of row) {
            if (element.trim() === '') {
                return;
            }
        }

        validRows.push(row);
    });

    return validRows;
}

export function removeRowsWithAllEmptyElements(rows: any[]): any[] {
    const validRows: any[] = [];

    rows.map((row) => {
        if (isEmpty(row)) {
            return;
        }

        for (let element of row) {
            if (element.trim() !== '') {
                validRows.push(row);
                return;
            }
        }
    });

    return validRows;
}
